import React from "react";
import { teamLabel, teamObj } from "@/components/manage/matchUtils";
import { TeamAvatar } from "@/components/common";

export default function Bracket({ matches, teamMap, onMatchClick }) {
  const mainMatches = matches.filter((m) => m.bracket === "main" || m.bracket === undefined);
  if (mainMatches.length === 0) return null;
  const rounds = [...new Set(mainMatches.map((m) => m.round))].sort((a, b) => a - b);

  return (
    <div className="flex gap-6 overflow-x-auto pb-4" data-testid="bracket-view">
      {rounds.map((r) => {
        const rm = mainMatches.filter((m) => m.round === r).sort((a, b) => a.slot - b.slot);
        return (
          <div key={r} className="flex min-w-[220px] flex-col justify-around gap-4">
            <div className="text-label text-center text-muted-foreground">{rm[0]?.round_name || `Round ${r}`}</div>
            {rm.map((m) => (
              <MatchNode key={m.id} m={m} teamMap={teamMap} onClick={onMatchClick} />
            ))}
          </div>
        );
      })}
    </div>
  );
}

function MatchNode({ m, teamMap, onClick }) {
  const isFinal = m.status === "final";
  return (
    <button
      type="button"
      onClick={() => onClick && onClick(m)}
      data-testid={`bracket-match-${m.id}`}
      className="group w-full rounded-xl border bg-card p-2 text-left transition-colors hover:border-primary/60"
    >
      <Side m={m} side="a" teamMap={teamMap} winner={isFinal && m.winner_id === m.team_a_id} />
      <div className="my-1 h-px bg-border" />
      <Side m={m} side="b" teamMap={teamMap} winner={isFinal && m.winner_id === m.team_b_id} />
    </button>
  );
}

function Side({ m, side, teamMap, winner }) {
  const t = teamObj(m, side, teamMap);
  const score = side === "a" ? m.score_a : m.score_b;
  return (
    <div className={`flex items-center justify-between gap-2 rounded-lg px-1.5 py-1 ${winner ? "bg-primary/10" : ""}`}>
      <div className="flex min-w-0 items-center gap-2">
        {t ? <TeamAvatar team={t} size={22} /> : <div className="h-[22px] w-[22px] rounded bg-muted" />}
        <span className={`truncate text-sm ${winner ? "font-bold" : t ? "font-medium" : "text-muted-foreground"}`}>
          {teamLabel(m, side, teamMap)}
        </span>
      </div>
      {score != null && <span className="font-heading font-black">{score}</span>}
    </div>
  );
}
